// ─── Emoji face helpers used in PreviewPanel ─────────────────────────────────

interface EmojiFaceProps {
  color: string;
  path: string;
  eyeY: number;
  label: string;
}

export function EmojiFace({ color, path, eyeY, label }: EmojiFaceProps) {
  return (
    <div className="pvx-face-wrap" title={label}>
      <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
        <circle cx="18" cy="18" r="16" fill={color} opacity=".15" stroke={color} strokeWidth="1.5"/>
        <circle cx="12" cy={eyeY} r="2" fill={color}/>
        <circle cx="24" cy={eyeY} r="2" fill={color}/>
        <path d={path} stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
      <span className="pvx-face-label" style={{ color }}>{label}</span>
    </div>
  );
}

export function NoObsFace() {
  const c = '#9CA3AF';
  return (
    <div className="pvx-face-wrap" title="N/O">
      <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
        <circle cx="18" cy="18" r="16" fill={c} opacity=".1" stroke={c} strokeWidth="1.5"/>
        <circle cx="18" cy="18" r="7" stroke={c} strokeWidth="1.5"/>
        <path d="M6 6l24 24" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
      <span className="pvx-face-label" style={{ color: c }}>N/O</span>
    </div>
  );
}
